import { container } from "@/inversify.config";
import { CatalogOperationVue } from "fs-pb-vue2/vueModels/operations/CatalogOperationVue";
import i18n from "@/i18n";
import IOperationsHistoryService from "fs-pb-vue2/services/history/IOperationsHistoryService";
import { RequestParamsModel } from "fs-pb-vue2/models/statement/requestParamsModel";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import { Watch } from "vue-property-decorator";
import { OperationModel } from "fs-pb-vue2/models/operations/operationModel";
import { OperationPropertyModel } from "fs-pb-vue2/models/operations/operationPropertyModel";
import { DeclarationPropertiesTypes } from "fs-pb-vue2/data";
import { TemplatesStore } from "fs-pb-vue2/store/modules/templates";
import { TemplateData } from "fs-pb-vue2/data/templateData";
import ITemplatesService from "fs-pb-vue2/services/templates/ITemplatesService";
import { getModule } from "vuex-module-decorators";

/**Модель представления операции */
export class CatalogOperationVueGB extends CatalogOperationVue {

	@Watch('OperationModel.NeedCompletePrepare', { immediate: true })
	needComplete(val: any) {
		if (val) {
			this.creditModalFlag = true;
		}
	}

	get templatesService(): ITemplatesService {
	return container.get<ITemplatesService>(DiTokens.TemplatesService);
	}

	/** Стор профиля */
	get templatesStore(): TemplatesStore {
	return getModule(TemplatesStore, this.$store);
	}

	get storeLoading(): boolean {
	return this.templatesStore.templatesLoading;
	}

	get simpleTemplates(): Array<TemplateData> {
	return this.templatesStore.simpleTemplates;
	}

	get periodTemplates(): Array<TemplateData> {
	return this.templatesStore.periodTemplates;
	}

	editMode: boolean = false;

	selectedTemplate: TemplateData = new TemplateData();

	modalDetails: any = null;

	operationsList: any = null;

	operInfo: boolean = false;

	modalLoading: boolean = false;

	creditModalFlag: boolean = false;

	get historyService(): IOperationsHistoryService {
		return container.get<IOperationsHistoryService>(DiTokens.OperationsHistoryService);
	}

	get acceptProps(): Array<any> {
		return this.OperationModel.Properties.filter((prop: OperationPropertyModel) => prop.Declaration.IsAccept && prop.ConfirmView !== 2);
	}

	get isAcceptTrueState(): boolean {
		const acceptProps: Array<OperationPropertyModel> = this.OperationModel.Properties.filter((prop: OperationPropertyModel) => {
			return prop.Declaration.IsAccept && prop.Declaration.Required && prop.Declaration.Type == DeclarationPropertiesTypes.String
				&& prop.Value.substring(0, 1) == '0'; 
		});

		if (acceptProps.length)
			return false;

		return true;
	}

	get caption(): string {
    if(this.$route.query.сreditRequest === 'true' && !this.isConfirm) {
      return this.OperationModel?.Declaration?.CaptionDeclaration
    }
    if(this.$route.query.сreditRequest === 'true' && this.isConfirm) {
      return i18n.t("main.creditRequest.isConfirm").toString()
    }
    return this.$route.query["_categoryName"] || this.OperationModel?.Declaration?.Caption;
  }

	get isSBPC2g(): boolean {
    return this.operId.toString() === this.configStore.apiData.OperationCodeOfSbpC2GOperation;
  }

	editTemplate(temp: TemplateData): void {
		this.selectedTemplate = temp;
		this.editMode = true;
  	}

	openAcceptLink(): void {
		//window.open(this.OperationModel.NeedCompletePrepare.acceptUrl, "_blank");
    	window.open(this.OperationModel.NeedCompletePrepare.acceptUrl, "EsiaPermission", "width=600,height=800,left=0,top=0,menubar=no,toolbar=no,location=no");
		this.creditModalFlag = false;
	}

	async cancelAccept(): Promise<void> {
		this.execLoading = true;
		this.OperationModel.NeedCompletePrepare.acceptProperty = '0';
		(this.OperationModel as OperationModel) = await this.service.prepare(this.OperationModel);
		this.creditModalFlag = false;
		this.execLoading = false;
	}

	/**Метод для выполнения после успешного проведения */
	async afterExecute(): Promise<void> {
		// await this.destroyForm();

		// this.appStore.setLoading(true);

		// this.successDetails = await this.detailsService.getOperationDetails({ Id: this.OperationModel.OperationId, ReferenceId: "" });
		// this.appStore.setLoading(false);

		await this.initOperationModal();
		await this.contractsStore.fetchContracts();
		sessionStorage.removeItem('calcCreditData');
		this.operInfo = true;
	}

	async showOperInfoDialog(operation: any) {
		this.modalLoading = true;
		this.modalDetails = await this.historyService.getOperationDetails(
		  operation
		);
		if (operation.sbpDetails) {
		  this.modalDetails.sbpDetails = operation.sbpDetails;
		}
		// this.fillStatementDetails();
		// Раскрасска хидера в цвет картинки
		try {
		  let pict;
		  if (!operation.Picture) {
		    pict = require('./../../../public/img/default-oper.png');
		  } else {
		    pict = operation.Picture;
		  }
		} catch(e) {
		  console.log(e);
			this.modalLoading = false;
		}
		this.modalLoading = false;
	}	

	async getOpeationsList() {

		const maxDate = new Date().toISOString().substr(0, 10);

		const resObj = await this.historyService.getOperationsHistory(
		  new RequestParamsModel({
		    dateBegin: maxDate.substring(0, 8) + "01",
		    dateEnd: maxDate,
		    contractId: '',
		    searchText: '',
		    sortType: 1,
		    filter: 31,
		    rootCatalog: this.catalogStore.catalog
		  })
		);

		return resObj;
	}

	async initOperationModal() {
		if (this.OperationModel.OperationId) {
		  if (!this.appStore.loading)
		    this.appStore.setLoading(true);
		  this.operationsList = await this.getOpeationsList();
		  if (this.operationsList && this.operationsList.length > 0) {
		    const operation: any = this.operationsList.find((oper: any) => oper.Id == this.OperationModel.OperationId);
		    this.showOperInfoDialog(operation ? operation : { Id: this.OperationModel.OperationId, ReferenceId: '' });
		  }
		  this.appStore.setLoading(false);
		}
	}
}